import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueInternationalization from 'vue-i18n';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import config from './config';
import api from './helper/api';
import { mergeLocales } from 'smartdoors-shared/js/helpers/i18n';
import registerSharedComponents from 'smartdoors-shared/js/components/registerComponents';
import BaseMixin from 'smartdoors-shared/js/components/Mixins/Base';
import Translation from 'smartdoors-shared/js/plugins/translation';

import { QrcodeStream } from "vue-qrcode-reader";

Sentry.init({
	Vue,
	dsn: "https://05276985ce1940f393017ec023403986@o314599.ingest.sentry.io/5853644",
	integrations: [new Integrations.BrowserTracing()],
  
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	// tracesSampleRate: 1.0,
    disablePerformance: true,
  });

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.register(self.location.origin + "/jsQR.min.js")
		.then(function () {})
}

Vue.config.productionTip = false

window.Vue = Vue;

/**
 * Internationalization
 */
const lang = 'de';

const i18n = new VueInternationalization({
	locale: lang,
	messages: mergeLocales({
		main: [
			require('smartdoors-shared/locales/main').default,
			require('./locales/main').default,
		],
		components: require('smartdoors-shared/locales/components').default,
		connectivity: require('./locales/connectivity').default,
		login: require('./locales/login').default,
		profile: require('smartdoors-shared/locales/profile').default,
		jobs: [
			require('smartdoors-shared/locales/jobs').default,
			require('./locales/jobs').default
		],
		notifications: require('smartdoors-shared/locales/notifications').default,
		messages: require('./locales/messages').default,
	})
});

Vue.use(Translation, { i18n });
Vue.use(QrcodeStream);
Vue.component('qrcode-stream', QrcodeStream);


/**
 * Register shared vue components
 */
registerSharedComponents(Vue);


/**
 * Register local vue components
 */
Vue.component('connectivity-badge', require('./components/ConnectivityBadge.vue').default);
Vue.component('job-list', require('./components/Jobs/JobList.vue').default);

/**
 * Icons
 */
const icons = require.context('smartdoors-shared/img/icons', false);

/**
 * Base helpers mixins
 */
Vue.mixin(BaseMixin);

Vue.mixin({
	data() {
		return {
			env: Object.entries(process.env).reduce((acc, [key, val]) => {
				if (key.indexOf('VUE_APP') === 0) {
					key = key.substr(8);
				}
				acc[key] = val;

				return acc;
			}, {}),
			appLocale: lang,
			api: api,
			config: config
		}
	},
	computed: {
		user() {
			return this.$store.state.user ? this.$store.state.user.data : null;
		}
	},
	methods: {
		icon: (icon) => {
			return icons(`./${icon}`);
		}
	}
});

window.vueBase = Vue.extend({
	router,
	store,
});

import JSONFormatter from 'json-formatter-js';

/**
 * Vue root instance
 */
new window.vueBase({
	render: h => h(App),
	created() {
		if (navigator.onLine && store.state.offline) {
			store.dispatch('online');
		} else if (!navigator.onLine && !store.state.offline) {
			store.dispatch('offline');
		}
	},
	mounted() {
		const logDiv = document.getElementById("error_log");

		if (logDiv) {
			const logWrapper = function (logOrig, container) {
				return function (value) {
					logOrig(value);

					if (value && typeof value == 'object' && 'message' in value && 'stack' in value) {
						value = value.message;
					}

					const formatter = new JSONFormatter(value);
					container.append(formatter.render());
				};
			};

			window.console.log = logWrapper(window.console.log.bind(window.console), logDiv);
			window.console.error = logWrapper(window.console.error.bind(window.console), logDiv);
			window.console.warn = logWrapper(window.console.warn.bind(window.console), logDiv);
		}
	}
}).$mount('#app');

const disableZoom = function (event) {
	event = event.originalEvent || event;
	if (event.scale > 1) {
		event.preventDefault();
		document.body.style.transform = 'scale(1)';
	}
};

window.addEventListener("touchmove", disableZoom, { passive: false });
window.addEventListener("gesturestart", disableZoom, { passive: false });